import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import styles from './PopularTags.module.css';

import type { TagData } from '@Pages/PageWikiMain/typings';
import type { FC, HTMLAttributes } from 'react';

export interface PopularTagsProp extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  tags: TagData[];
}

const PopularTags: FC<PopularTagsProp> = (props) => {
  const { className, tags, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.popularTags, className)}>
      <div className={styles.title}>{t('popular-tags')}</div>

      <div className={styles.tagsWrapper}>
        {tags.map((tag, index) => (
          <Button
            theme='transparent'
            view='rounded'
            to={tag.link}
            className={styles.tagItem}
            key={index}
          >
            {tag.title}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default memo(PopularTags);
